import * as tslib_1 from "tslib";
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from '../base.service';
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var VirtualGoodService = /** @class */ (function (_super) {
    tslib_1.__extends(VirtualGoodService, _super);
    function VirtualGoodService(http) {
        var _this = _super.call(this, 'virtual-good', http) || this;
        _this.http = http;
        return _this;
    }
    VirtualGoodService.prototype.ngOnInit = function () {
    };
    VirtualGoodService.prototype.getAllVirtualGoodsByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        // const sortStr = sortOprions.getSortString();
        return this.http.get(this.url + "?" + ("" + paging.getPagingStr() + (this.embeddedStr + searchCondition) + "&sort=id,desc")).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    VirtualGoodService.prototype.getAllRedByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var str = '&f_category_op==&f_category=9';
        return this.http.get(this.url + "?" + ("" + paging.getPagingStr() + (this.embeddedStr + searchCondition + str) + "&sort=id,desc")).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    VirtualGoodService.prototype.getAllOtherByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        // const sortStr = sortOprions.getSortString();
        var str = '&f_category_op==&f_category=10';
        return this.http.get(this.url + "?" + ("" + paging.getPagingStr() + (this.embeddedStr + searchCondition + str) + "&sort=id,desc")).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    VirtualGoodService.prototype.getAllByBusinessIdByPaging = function (searchCondition, businessId, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition) + "&sort=id,desc" + (businessId ? "&f_businessId=" + businessId + "&f_businessId_op==" : '')).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    VirtualGoodService.prototype.getAllByWalletIdsByPaging = function (walletIds, searchCondition, paging) {
        var sortStr = '&sort=id,asc';
        var walletIdsStr = '';
        if (walletIds) {
            walletIds.forEach(function (id) {
                walletIdsStr += "&f_acceptedMerchants=" + id;
            });
        }
        if (walletIdsStr) {
            walletIdsStr += '&f_acceptedMerchants_op=IN';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + walletIdsStr + sortStr + searchCondition).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    VirtualGoodService.prototype.publishCouponById = function (id) {
        return this.http.post(this.url + "/" + id + "/dispatch", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    VirtualGoodService.prototype.deleteVg = function (id) {
        return this.http.post(this.url + "/" + id + "/delete", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    VirtualGoodService.prototype.addPrize = function (value) {
        return this.http.post(this.url + "/add-prize", value).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    return VirtualGoodService;
}(BaseService));
export { VirtualGoodService };
